
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import BottomNavigation from '../../components/feature/BottomNavigation';

export default function Home() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [currentLocation] = useState('الرياض، حي الملز');

  const promoOffers = [
    {
      id: 1,
      title: 'خصم 20% على أول رحلة',
      description: 'للمستخدمين الجدد',
      code: 'WELCOME20',
      color: 'from-[#F9A826] to-[#E8971F]'
    },
    {
      id: 2,
      title: 'رحلة مجانية',
      description: 'عند إحالة 3 أصدقاء',
      code: 'REFER3',
      color: 'from-[#0056A6] to-[#0066CC]'
    }
  ];

  const quickActions = [
    {
      id: 1,
      title: 'المطار',
      icon: 'ri-plane-line',
      destination: 'مطار الملك خالد الدولي'
    },
    {
      id: 2,
      title: 'المستشفى',
      icon: 'ri-hospital-line',
      destination: 'مستشفى الملك فهد'
    },
    {
      id: 3,
      title: 'التسوق',
      icon: 'ri-shopping-bag-line',
      destination: 'مول الرياض'
    },
    {
      id: 4,
      title: 'الجامعة',
      icon: 'ri-school-line',
      destination: 'جامعة الملك سعود'
    }
  ];

  return (
    <div className="min-h-screen bg-[#FDFDFD] pb-20">
      {/* Header */}
      <div className="bg-gradient-to-r from-[#0056A6] to-[#0066CC] pt-12 pb-6 px-4 relative overflow-hidden">
        {/* Background Pattern */}
        <div className="absolute inset-0 opacity-10">
          <div className="absolute top-4 right-8 w-16 h-16 border border-white/30 rounded-full"></div>
          <div className="absolute bottom-2 left-12 w-12 h-12 border border-white/30 rounded-full"></div>
        </div>

        <div className="relative z-10">
          {/* Top Bar */}
          <div className="flex items-center justify-between mb-6">
            <div className="flex items-center">
              <div className="w-10 h-10 bg-white/20 rounded-full flex items-center justify-center mr-3">
                <i className="ri-map-pin-line text-white text-lg"></i>
              </div>
              <div>
                <p className="text-white/80 text-xs">موقعك الحالي</p>
                <p className="text-white font-medium text-sm">{currentLocation}</p>
              </div>
            </div>
            <button className="w-10 h-10 bg-white/20 rounded-full flex items-center justify-center">
              <i className="ri-notification-line text-white text-lg"></i>
            </button>
          </div>

          {/* App Title */}
          <div className="text-center mb-6">
            <h1 className="text-2xl font-bold text-white mb-1" style={{ fontFamily: 'Pacifico, serif' }}>
              موف برو
            </h1>
            <p className="text-white/80 text-sm">خدمات النقل الذكي</p>
          </div>
        </div>
      </div>

      {/* Interactive Map Placeholder */}
      <div className="mx-4 -mt-8 mb-6 relative z-20">
        <div className="bg-white rounded-2xl shadow-lg overflow-hidden border border-gray-100">
          <div className="h-48 bg-gradient-to-br from-gray-100 to-gray-200 relative">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3624.1!2d46.6753!3d24.7136!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMjTCsDQyJzQ5LjAiTiA0NsKwNDAnMzEuMSJF!5e0!3m2!1sen!2ssa!4v1"
              width="100%"
              height="100%"
              style={{ border: 0 }}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              className="rounded-t-2xl"
            ></iframe>
            <div className="absolute bottom-4 left-4 bg-white/90 backdrop-blur-sm rounded-lg px-3 py-2">
              <p className="text-xs text-gray-600">الموقع الحالي</p>
              <p className="text-sm font-medium text-gray-800">{currentLocation}</p>
            </div>
          </div>
        </div>
      </div>

      <div className="px-4">
        {/* Main Service Options */}
        <div className="mb-6">
          <h2 className="text-xl font-bold text-gray-800 mb-4">كيف تريد السفر؟</h2>
          <div className="space-y-4">
            {/* Regular Ride */}
            <button
              onClick={() => navigate('/booking')}
              className="w-full bg-gradient-to-r from-[#0056A6] to-[#0066CC] rounded-2xl p-6 text-white shadow-lg hover:shadow-xl transition-all duration-300"
            >
              <div className="flex items-center justify-between">
                <div className="flex items-center">
                  <div className="w-14 h-14 bg-white/20 rounded-xl flex items-center justify-center mr-4">
                    <i className="ri-car-line text-2xl"></i>
                  </div>
                  <div className="text-right">
                    <h3 className="text-lg font-bold mb-1">🚗 طلب عادي</h3>
                    <p className="text-white/80 text-sm">سعر ثابت بناءً على المسافة</p>
                  </div>
                </div>
                <i className="ri-arrow-left-line text-xl"></i>
              </div>
            </button>

            {/* Bidding Ride */}
            <button
              onClick={() => navigate('/booking/bidding')}
              className="w-full bg-gradient-to-r from-[#F9A826] to-[#E8971F] rounded-2xl p-6 text-white shadow-lg hover:shadow-xl transition-all duration-300"
            >
              <div className="flex items-center justify-between">
                <div className="flex items-center">
                  <div className="w-14 h-14 bg-white/20 rounded-xl flex items-center justify-center mr-4">
                    <i className="ri-auction-line text-2xl"></i>
                  </div>
                  <div className="text-right">
                    <h3 className="text-lg font-bold mb-1">💰 طلب خاص</h3>
                    <p className="text-white/80 text-sm">نظام المزايدة للحصول على أفضل سعر</p>
                  </div>
                </div>
                <i className="ri-arrow-left-line text-xl"></i>
              </div>
            </button>
          </div>
        </div>

        {/* Promotional Offers */}
        <div className="mb-6">
          <h3 className="text-lg font-bold text-gray-800 mb-4">العروض الحصرية</h3>
          <div className="space-y-3">
            {promoOffers.map((offer) => (
              <div
                key={offer.id}
                className={`bg-gradient-to-r ${offer.color} rounded-xl p-4 text-white relative overflow-hidden`}
              >
                <div className="absolute top-0 right-0 w-20 h-20 bg-white/10 rounded-full -mr-10 -mt-10"></div>
                <div className="relative z-10">
                  <div className="flex items-center justify-between">
                    <div>
                      <h4 className="font-bold text-lg mb-1">{offer.title}</h4>
                      <p className="text-white/90 text-sm mb-2">{offer.description}</p>
                      <div className="bg-white/20 rounded-lg px-3 py-1 inline-block">
                        <span className="text-xs font-medium">كود: {offer.code}</span>
                      </div>
                    </div>
                    <i className="ri-gift-line text-3xl text-white/80"></i>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Quick Actions */}
        <div className="mb-6">
          <h3 className="text-lg font-bold text-gray-800 mb-4">وجهات سريعة</h3>
          <div className="grid grid-cols-2 gap-3">
            {quickActions.map((action) => (
              <button
                key={action.id}
                onClick={() => navigate('/booking', { state: { destination: action.destination } })}
                className="bg-white rounded-xl p-4 border border-gray-100 hover:border-[#0056A6] hover:shadow-md transition-all duration-200"
              >
                <div className="text-center">
                  <div className="w-12 h-12 bg-gradient-to-br from-[#0056A6]/10 to-[#F9A826]/10 rounded-xl flex items-center justify-center mx-auto mb-3">
                    <i className={`${action.icon} text-[#0056A6] text-xl`}></i>
                  </div>
                  <h4 className="font-medium text-gray-800 text-sm">{action.title}</h4>
                </div>
              </button>
            ))}
          </div>
        </div>

        {/* Recent Activity */}
        <div className="mb-6">
          <div className="flex items-center justify-between mb-4">
            <h3 className="text-lg font-bold text-gray-800">النشاط الأخير</h3>
            <button 
              onClick={() => navigate('/orders')}
              className="text-[#0056A6] text-sm font-medium"
            >
              عرض الكل
            </button>
          </div>
          <div className="bg-white rounded-xl p-4 border border-gray-100">
            <div className="flex items-center">
              <div className="w-10 h-10 bg-green-100 rounded-full flex items-center justify-center mr-3">
                <i className="ri-check-line text-green-600"></i>
              </div>
              <div className="flex-1">
                <p className="font-medium text-gray-800 text-sm">رحلة إلى مول الرياض</p>
                <p className="text-gray-500 text-xs">اليوم، 2:30 م - 25 ريال</p>
              </div>
              <button className="text-[#0056A6] text-sm font-medium">
                إعادة الطلب
              </button>
            </div>
          </div>
        </div>
      </div>

      <BottomNavigation />
    </div>
  );
}
